/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2021-05-26 16:03:03
 */
import React from 'react';
// @ts-ignore
import s from './form.css';
import MysketchPicker from '../../../components/MysketchPicker/MysketchPicker';
import Collapse, {Panel} from '../../../components/Collapse/Collapse';

class CustomizedForm extends React.Component {
  change = (key, val) => {
    const onChange = this.props.onChange
    onChange({}, {
      [key]: {
        value: val
      }
    })
  }
  render () {
    const {...props} = this.props
    return (
      <Collapse className={s.collapse}>
        <Panel header="主标题">
          <label className={s.label}>
            <span className={s.labelTit}>内容：</span> 
            <input value={props['titleText'].value} onChange={e => {
              this.change('titleText', e.target.value)
            }} />
          </label>
          <label className={s.label}>
            <span className={s.labelTit}>颜色：</span>
            <MysketchPicker value={props['titleColor'].value} onChange={value => {
              this.change('titleColor', value)
            }} />
          </label>
          <label className={s.label}>
            <span className={s.labelTit}>字体大小：</span>
            <input value={props['titleSize'].value} onChange={e => {
              this.change('titleSize', e.target.value)
            }} />
          </label>
          <label className={s.label}>
            <span className={s.labelTit}>加粗：</span>
            <input type="checkbox" value="true"
              checked={props['titleWeight'].value === true}
              onChange={e => {
                this.change('titleWeight', !props['titleWeight'].value)
              }} 
            />
          </label>
        </Panel>
        <Panel header="副标题">
          <label className={s.label}>
            <span className={s.labelTit}>内容：</span>
            <input value={props['subTitleText'].value} onChange={e => {
              this.change('subTitleText', e.target.value)
            }} />
          </label>
          <label className={s.label}>
            <span className={s.labelTit}>颜色：</span>
            <MysketchPicker value={props['subTitleColor'].value} onChange={value => {
              this.change('subTitleColor', value)
            }} />
          </label>
          <label className={s.label}>
            <span className={s.labelTit}>字体大小：</span>
            <input value={props['subTitleSize'].value} onChange={e => {
              this.change('subTitleSize', e.target.value)
            }} />
          </label>
          <label className={s.label}>
            <span className={s.labelTit}>加粗：</span>
            <input type="checkbox" value="true"
              checked={props['subTitleWeight'].value === true}
              onChange={e => {
                this.change('subTitleWeight', !props['subTitleWeight'].value)
              }} 
            />
          </label>
        </Panel>
        <Panel header="图表宽高">
          <label className={s.label}>
            <span className={s.labelTit}>宽度：</span>
            <input value={props['chartWidth'].value} onChange={e => {
              this.change('chartWidth', e.target.value)
            }} />
          </label>
          <span style={{color: '#f00', marginLeft: 10}}>通过设置宽度，显示完整数据</span>
          <label className={s.label}>
            <span className={s.labelTit}>高度：</span>
            <input value={props['chartHeight'].value} onChange={e => {
              this.change('chartHeight', e.target.value)
            }} />
          </label>
        </Panel>
      </Collapse>
    )
  }
}

export { CustomizedForm }


// WEBPACK FOOTER //
// src/routes/customChart/components/baseForm.js